import React, { useMemo, useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';
import RegistryDashboard from './RegistryDashboard';
import CoreDatasheet from './CoreDatasheet';
import ProtocolRegistration from '../protocolRegistration/ProtocolRegistration';
import ResultSubmission from './ResultSubmission';
import PolicyRulebook from './PolicyRulebook';
import ScrollToTop from '../common/ScrollToTop';
import RedactionsTab from './RedactionsTab';


const tabConfig = [
  { id: 'dashboard', label: 'Dashboard', component: RegistryDashboard },
  { id: 'core-datasheet', label: 'Core Datasheet', component: CoreDatasheet },
  { id: 'protocol-registration', label: 'Protocol Registration', component: ProtocolRegistration },
  { id: 'result-submission', label: 'Result Submission', component: ResultSubmission },
  { id: 'policy-rulebook', label: 'Policy Rulebook', component: PolicyRulebook },
  { id: 'redactions', label: 'Redactions', component: RedactionsTab },

];

const RegistryManagement = ({ projectId }) => {
  const [activeTab, setActiveTab] = useState(tabConfig[0].id);

  const ActiveComponent = useMemo(() => {
    const match = tabConfig.find((tab) => tab.id === activeTab);
    return match ? match.component : tabConfig[0].component;
  }, [activeTab]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 2 }} elevation={0}>
        <Typography variant="h5" gutterBottom>
          Registry Management
        </Typography>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 3 }}
        >
          {tabConfig.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.id} />
          ))}
        </Tabs>

        <ActiveComponent projectId={projectId} />

        {/* Scroll to Top Button */}
        <ScrollToTop />
      </Paper>
    </Box>
  );
};

export default RegistryManagement;

